import React from "react";

const CustomPagination = ({ currentPage, pageCount, handlePrev, handleNext }) => {
  return (
    <div className="pagination-wrapper d-flex align-items-center justify-content-center">
      <a className="prev-page " onClick={handlePrev}>
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 7.00391C18.5523 7.00391 19 7.45162 19 8.00391C19 8.55619 18.5523 9.00391 18 9.00391V7.00391ZM0.292892 8.71101C-0.0976315 8.32049 -0.0976315 7.68732 0.292892 7.2968L6.65685 0.932838C7.04738 0.542314 7.68054 0.542314 8.07107 0.932838C8.46159 1.32336 8.46159 1.95653 8.07107 2.34705L2.41421 8.00391L8.07107 13.6608C8.46159 14.0513 8.46159 14.6844 8.07107 15.075C7.68054 15.4655 7.04738 15.4655 6.65685 15.075L0.292892 8.71101ZM18 9.00391L1 9.00391V7.00391L18 7.00391V9.00391Z"
            fill="#161F28"
          ></path>
        </svg>
      </a>

      <div className="current-page mx-4">
        {currentPage + 1 < 10 ? "0" : ""}
        {currentPage + 1} / {pageCount < 10 ? "0" : ""}
        {pageCount}
      </div>

      <a className="next-page" onClick={handleNext}>
        <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 7.00391C18.5523 7.00391 19 7.45162 19 8.00391C19 8.55619 18.5523 9.00391 18 9.00391V7.00391ZM0.292892 8.71101C-0.0976315 8.32049 -0.0976315 7.68732 0.292892 7.2968L6.65685 0.932838C7.04738 0.542314 7.68054 0.542314 8.07107 0.932838C8.46159 1.32336 8.46159 1.95653 8.07107 2.34705L2.41421 8.00391L8.07107 13.6608C8.46159 14.0513 8.46159 14.6844 8.07107 15.075C7.68054 15.4655 7.04738 15.4655 6.65685 15.075L0.292892 8.71101ZM18 9.00391L1 9.00391V7.00391L18 7.00391V9.00391Z"
            fill="#161F28"
          ></path>
        </svg>
      </a>
    </div>
  );
};

export default CustomPagination;
